var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPathwaysIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 174.27 194.87",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2-2",
    "data-name": "Layer 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2-2",
    "data-name": "Layer 1-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.34,137.18,33.28,101.09a5.56,5.56,0,0,1,0-7.83l7.84-7.83a5.52,5.52,0,0,1,7.83,0h0l24.3,24.29,52.05-52a5.56,5.56,0,0,1,7.85,0L141,65.54a5.53,5.53,0,0,1,0,7.84l-63.8,63.8A5.55,5.55,0,0,1,69.34,137.18Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M174.27,96.77c0-42.68-28.56-78.44-67-87.87a5.25,5.25,0,0,0-2.55,10.18c33,8.44,57.43,40,57.43,77.69,0,35-21.1,64.68-50.49,75.51L117,159a4.38,4.38,0,0,0-2.44-5.68h0a4.37,4.37,0,0,0-5.68,2.44l-8.8,22a4.35,4.35,0,0,0,1.3,7.3l23.77,9.48a4.37,4.37,0,1,0,3.24-8.11l-11.75-4.69C150.25,169.21,174.27,135.91,174.27,96.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.32,9,47.26.26a4.38,4.38,0,0,0-5.6,2.62h0a4.38,4.38,0,0,0,2.62,5.6l11.29,4.11C23.05,25.69,0,58.43,0,96.77c0,42.68,28.56,78.44,67,87.87a5.25,5.25,0,0,0,2.55-10.18c-32.95-8.44-57.44-40-57.44-77.69,0-34.58,20.64-64,49.52-75.14L56.52,35.57a4.36,4.36,0,0,0,2.61,5.6h0a4.36,4.36,0,0,0,5.6-2.61l8-22c.07-.13.13-.27.19-.4a4.26,4.26,0,0,0,1-1.59A4.36,4.36,0,0,0,71.32,9Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPathwaysIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pathways_icon.a12311a1.svg";
export { ForwardRef as ReactComponent };